import type { CanMatchFn } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries -- designer flag from the eager ports entry, not the lazy editor
import { DESIGNER_MODE_ENABLED } from '@lite-workspace/album-editor/ports';

// canMatch, not canActivate: while the designer is off the route must not match at all, so the chunk is never
// fetched and a hand-typed URL falls through to the wildcard instead of rendering the designer.
export const designerModeGuard: CanMatchFn = () => DESIGNER_MODE_ENABLED;
